import { Container } from '@chakra-ui/react';
import JobListings from './JobListingsPage';

const JobsPage = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <JobListings />
    </Container>
  );
};

export default JobsPage;